FreeShipping = window.FreeShipping ?= {}

DealEventPipe = require '../../../deal/frontend/event_pipe'

FreeShipping.View = Backbone.View.extend
  initialize: ->
    @$message = $('.free-shipping-container')

    DealEventPipe.on "priceUpdate", (priceData) =>
      @updateFreeShipping priceData

  updateFreeShipping: ({uuid}) ->
    if @options.freeShippingValues[uuid]
      @$message.show()
    else
      @$message.hide()


module.exports = FreeShipping.View
